export class OrganizerEntity {
  organizerEmail: string;
  hasAssistant: boolean;
  defaultAssistantEmail: string;
  defaultAssistantName: number;

  constructor(data?: Partial<OrganizerEntity>) {
    this.defaultAssistantEmail = data?.defaultAssistantEmail || "";
    this.defaultAssistantName = data?.defaultAssistantName || 0;
    this.hasAssistant = data?.hasAssistant || false;
    this.organizerEmail = data?.organizerEmail || "";
  }
}
